// Module
var code = "<div style=\"background:red;color:#fff\"> <pre>[[ message ]]</pre> </div> ";
// Exports
export default code;